import React, { Component } from "react";
import { Modal, message, Spin, Button, Icon, Tabs } from "antd";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";
import dictCache from "../../../common/dictCache";
import InvInfor from "./components/InvInfor.js";
import InvServiceContent from "./components/InvServiceContent.js";
import ClientParams from "./components/ClientParams.js";
import ForecastParams from "./components/ForecastParams.js";
import VisitingPlan from "./components/VisitingPlan.js";
import KeyAnalysis from "./components/KeyAnalysis.js";
import Fetch from "../../../common/Fetch.js";
import ExportUtil from "../../../common/ExportUtil.js";
import TotalPrice from "./components/TotalPrice.js";
import AnnualThroughput from "./components/AnnualThroughput.js";
import FTEQuoteRule from "./components/FTEQuoteRule.js";

const TabPane = Tabs.TabPane;

const Config = {
    edit: {
        title: "修改",
    },
    view: {
        title: "查看",
    },
};

class Update extends Component {
    state = {
        params: {},
        type: "view",
        visible: false,
        loading: false,
        fileList: [],
        byStageList: [],
        evaluateServeConfigList: [], //项目服务内容
        researchProductTypeList: [],
        record: {},
        activeKey: 'VisitAssess',
        tabs: [],
        changeData: {},
    };

    dictLoaded = false

    show = (record, type) => {
        // 研究产品类型字典与项目数据无关，首开一次；请求失败则下次打开自动重试
        if (!this.dictLoaded) {
            this.queryConfigWithChildByType()
        }
        const { evaluateRecordId, quotationType } = record;
        const { tabs } = this.state;
        this.loadData(evaluateRecordId);
        if (quotationType == 'VISIT_QUOTATION') {
            tabs.push({
                tab:'访视评估',
                key:'VisitAssess',
            });
        } else if (quotationType == 'FTE_QUOTATION') {
            tabs.push({
                tab:'一口价（建议评估）',
                key:'FTEAssess',
            });
        } else if (quotationType == 'VISIT_FTE_QUOTATION') {
            tabs.push({
                tab:'访视评估',
                key:'VisitAssess',
            },{
                tab:'一口价（建议评估）',
                key:'FTEAssess',
            });
        } else {
            tabs.push({
                tab:'访视评估',
                key:'VisitAssess',
            });
        }
        this.setState({
            visible: true,
            type,
            record,
            tabs,
            activeKey: quotationType == 'FTE_QUOTATION' ? 'FTEAssess' : 'VisitAssess',
        });
    };

    loadData = (evaluateRecordId) => {
        this.setState({ loading: true });
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateRecordView,//项目基本信息
                        evaluateRecordCustomer,//客户项目参数
                        evaluateServeConfigList, //项目服务内容
                        evaluateRecordServeList,//项目服务内容-选中的值
                    },
                    changeData,
                } = res;
                const evaluateRecordServeIds = (evaluateRecordServeList || []).map(el => el.evaluateServeId).join(',');
                this.setState(
                    {
                        params: {
                            evaluateRecordId,
                            ...evaluateRecordView,
                            ...evaluateRecordCustomer,
                            evaluateRecordServeIds,
                            sponsorCompanyName: evaluateRecordView.sponsorName,
                        },
                        loading: false,
                        evaluateServeConfigList,
                        changeData,
                    },() => 
                    {
                        this.handelfirstOption()
                        this.queryEnclosureFileList()
                    }
                );
            },
        }
        $.sendRequest(options);
    }

    handelfirstOption = () => {
        const { researchProductTypeList, params } = this.state;
        params[`researchProductTypeIdValue`] = params.researchProductTypePCId ? params.researchProductTypePCId.split(',') : [];
        params[`researchProductTypeIdValue`] = params[`researchProductTypeIdValue`].map(el => el = Number(el));
        if(!!params[`researchProductTypeIdValue`].length) {
            const researchProductTypeItem = researchProductTypeList.find(el => params[`researchProductTypeIdValue`][0] == el.evaluateConfigureId )
            const code = researchProductTypeItem ? researchProductTypeItem.code : undefined;
            if (code) {
                Fetch.post(API_URL.common.queryInvestigationByStageByMedicine, { 
                    investigationMedicineType: code
                })
                    .then(res => {
                        this.setState({ byStageList: res.data });
                    })
                    .catch(error => console.log(error));
            } else {
                this.setState({ byStageList: [] });
            }
        }
    }

    queryEnclosureFileList = () => {
        const { params: { evaluateRecordId } } = this.state
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEnclosureFileList,
            data: { 
                relateId: evaluateRecordId,
                uploadType: 'EVALUATE_RECORD_CUSTOMER_FILE'
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.datas || [];
                fileList.forEach(item => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = item.fileMateId;
                });
                this.setState({
                    fileList,
                });
            }
        };
        $.sendRequest(options);
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.dictLoaded = true;
            this.setState({
                researchProductTypeList: res.list,
            }, () => {
                // 项目数据先于字典返回时，此处补偿计算项目分期
                this.handelfirstOption();
            });
        });
    }

    hide = () => {
        this.setState({
            params: {},
            fileList: [],
            visible: false,
            loading: false,
            record: {},
            activeKey: 'VisitAssess',
            tabs: [],
        });
    };

    splitParams = params => {
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object') {
                result[key] = value;
            }
        }
        return result;
    }

    handelRequired = () => {
        const { params } = this.state;
        const InvInforConfig =  this.InvInforRef.handleDomRender();
        const ClientParamsConfig =  this.ClientParamsRef.handleDomRender();
        try {
            InvInforConfig.map(el => {
                const { name, label, type, required = false } = el;
                if(required) {
                    if(type === 'InputNumber' || type === 'Select') {
                        if( params[name] === undefined || params === null || params === '' ) {
                            throw label
                        }
                    } else if(type === 'SearchRetrieve') {
                        if( !params[`${name}Id`] || !params[`${name}Name`]) {
                            throw label
                        }
                    } else if( !params[name] ) {
                        throw label
                    }
                }
            })
            ClientParamsConfig.map(el => {
                const { name, label, type, required = false } = el;
                if(required) {
                    if(type === 'InputNumber' || type === 'Select') {
                        if( params[name] === undefined || params[name] === null || params === null || params === '' ) {
                            throw label
                        }
                    } else if( !params[name] ) {
                        throw label
                    }
                }
            })
        } catch (error) {
            message.warning(`请填写${error}！`);
            return false
        }
        return true
    }

    submit = () => {
        const { params, type } = this.state;
        if(!this.handelRequired()) {
            return
        }
        params.createTime = undefined;
        this.setState({ loading: true });
        const options = {
            method: "POST",
            url: API_URL.evaluate.saveEvaluateServeCustomer,
            data: {
                ...this.splitParams(params),
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success);
                this.setState(
                    {
                        loading: false,
                    },
                    () => {
                        this.hide();
                        this.props.loadData();
                    }
                );
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    };

    handleParamsChange = (params) => {
        this.setState({ params:{
            ...params,
        } });
    };

    handleEvaluateServeChange = (value) => {
        this.setState({ 
            evaluateServeConfigList: JSON.parse(value)
        });
        this.saveEvaluateServeValue(JSON.parse(value))
    }

    saveEvaluateServeValue = (config = []) => {
        const { params } = this.state;
        const evaluateRecordServeIds = [];
        config.map(item => {
            const { children = [] } = item;
            children.map( child => {
                const { children = [] } = child;
                children.map(option => {
                    const { selected, evaluateServeId } = option;
                    if(selected) evaluateRecordServeIds.push(evaluateServeId);
                }) 
            })
        })
        this.setState({
            params: {
                ...params,
                evaluateRecordServeIds: evaluateRecordServeIds.join(',')
            }
        })
    }

    dataExport = () => {
        const { params, activeKey } = this.state;
        const { evaluateRecordId, evaluateSerialNumber } = params;
        const url =  activeKey === 'VisitAssess' ? API_URL.evaluate.exportEvaluateRecordVisit : API_URL.evaluate.exportEvaluateRecordFte;
        ExportUtil.export({ evaluateRecordId, evaluateSerialNumber }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    handleTabClick = (key) => {
        this.setState({ activeKey: key });
    }

    showDockingData = (evaluateRecordId) => {
        window.open(`./#/clinicalEvaluation/DockingData?evaluateRecordId=${evaluateRecordId}`);
    }

    updateEvaluateParams = () => {
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{marginLeft: 42}}>确认一键覆盖已更新的评估参数吗？</div>,
            content: '一旦覆盖，再有数据调整需要手动更新',
            onOk: () => {
                this.InvInforRef.updateInvInforParams();
                setTimeout(() => {
                    this.ClientParamsRef.updateClientParams();
                }, 100);
            },
        });
    }

    render() {
        const { 
            visible, 
            loading, 
            params, 
            changeData,
            type,
            fileList,
            byStageList,
            evaluateServeConfigList,
            researchProductTypeList,
            record,
            activeKey,
            tabs,
        } = this.state;
        const { changeFieldList = [] } = changeData || {};
        const {
            evaluateRecordId,
            needCoverData,
        } = params;
        const { curRole } = sessionStorage;
        const { talAuth, deptBoAuth, bdBaAuth, seniorUserAuth, finAuth } = record;
        const restrict = (seniorUserAuth || talAuth || deptBoAuth || bdBaAuth || curRole === 'BDO' || curRole === 'BAL' || finAuth);
        const DomArr = [
            {
                title: type === 'view' ? <span>
                    项目基本信息
                    <a 
                        style={{marginLeft: 10}}
                        onClick={() => this.showDockingData(evaluateRecordId)}
                    >
                        <Icon type="file-text" />
                    </a></span> : <span>
                        项目基本信息
                        {(changeFieldList.length !== 0 && needCoverData == '1') &&
                            <Button 
                                style={{ marginLeft: 15 }}
                                type="primary" 
                                onClick={() => this.updateEvaluateParams()}
                            >
                                评估参数更新
                            </Button>
                        }
                    </span>,
                show: true,
                Dom: <InvInfor 
                        key='InvInfor'
                        type={type}
                        params={params}
                        changeData={changeData}
                        byStageList={byStageList}
                        researchProductTypeList={researchProductTypeList}
                        ref={el => this.InvInforRef = el}
                        handleParamsChange={this.handleParamsChange}
                    />
            },
            {
                title: '项目服务内容',
                show: true,
                Dom: <InvServiceContent 
                        key='InvServiceContent'
                        type={type}
                        params={params} 
                        Config={evaluateServeConfigList}
                        handleParamsChange={this.handleParamsChange}
                        handleEvaluateServeChange={this.handleEvaluateServeChange}
                    />
            },
            {
                title: '客户项目参数',
                show: true,
                Dom: <ClientParams 
                        key='ClientParams'
                        type={type}
                        isCheck={true}
                        record={record}
                        params={params}
                        changeData={changeData}
                        fileList={fileList}
                        ref={el => this.ClientParamsRef = el}
                        handleParamsChange={this.handleParamsChange}
                    />
            },
            {
                title: '临床PM参照临床方案预测项目参数',
                key: 'ForecastParams',
                show: type === 'view' && activeKey === 'VisitAssess',
                Dom: <ForecastParams 
                        key='ForecastParams'
                        record={record}
                        type={type}
                        showButn={false}
                        evaluateRecordId={evaluateRecordId}
                    />
            },
            {
                title: '临床PM参照临床方案预测项目方案',
                key: 'VisitingPlan',
                show: type === 'view' && activeKey === 'VisitAssess',
                Dom: <VisitingPlan 
                        key='VisitingPlan'
                        type={type}
                        evaluateRecordId={evaluateRecordId}
                        record={record}
                        showButn={false}
                    />
            },
            {
                title: 'FTE报价规划',
                key: 'VisitingPlan',
                show: type === 'view' && activeKey === 'FTEAssess',
                Dom: <FTEQuoteRule
                        key='FTEQuoteRule'
                        type={type}
                        record={record}
                        pageName='view'
                        showButn={false}
                        evaluateRecordId={evaluateRecordId}
                    />
            },
            {
                title: '重点难点分析&其他备注说明',
                key: 'KeyAnalysis',
                show: type === 'view',
                Dom: <KeyAnalysis 
                        key='KeyAnalysis'
                        showButn={false}
                        type={type}
                        evaluateRecordId={evaluateRecordId}
                        quotationType={activeKey === 'VisitAssess' ? 'VISIT_QUOTATION' : 'FTE_QUOTATION'}
                    />
            },
            {
                title: '评估总价',
                key: 'TotalPrice',
                show: (type === 'view' && activeKey === 'VisitAssess' && (seniorUserAuth || talAuth || deptBoAuth || finAuth)),
                Dom: <TotalPrice
                        key='TotalPrice'
                        type={type}
                        showButn={false}
                        evaluateRecordId={evaluateRecordId}
                    />
            },
            {
                title: '年产出',
                key: 'AnnualThroughput',
                show: (type === 'view' && activeKey === 'VisitAssess' && restrict),
                Dom: <AnnualThroughput
                        key='AnnualThroughput'
                        type={type}
                        showButn={false}
                        evaluateRecordId={evaluateRecordId}
                    />
            },
        ];
        return (
            <Modal
                title={`${Config[type].title}临床报价评估`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                confirmLoading={loading}
                width={1000}
                bodyStyle={{
                    minHeight: 700
                }}
                footer={type === 'view' ?
                    <Button key="cancel" onClick={this.hide}>关闭</Button> :
                    [
                        <Button key="cancel" onClick={this.hide}>取消</Button>,
                        <Button key="ok" type="primary" onClick={this.submit} loading={loading}>确定</Button>,
                    ]
                }
            >
                <Spin spinning={loading}>
                    <div
                        className="modal-content"
                        style={{ padding: "0 20px" }}
                    >
                        {
                            type === 'view' && <div>
                                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                                    {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                                </Tabs>
                                <div style={{float: 'right'}}>
                                    <Button key="exprot" type="primary" onClick={this.dataExport}>导出</Button>
                                </div>
                            </div>
                        }
                        {
                            DomArr.filter(data => data.show == true).map((el, index) => {
                                return <div>
                                            <div style={{ 
                                                fontSize: 14,
                                                fontWeight: '700',
                                                margin: '10px 0'
                                            }}>
                                                {`${index + 1 }.`}{el.title}
                                            </div>
                                            {el.Dom}
                                        </div>
                            })
                        }
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/Update.js